module.exports = __webpack_public_path__ + "img/ppoint.ae1ab33f.png";